export default __webpack_public_path__ + "static/media/floor-13.6cb77a9d.jpg";